import { createContext } from 'react';
import type { TExperienceListContextValue } from './ExperienceList.types.ts';

export const ExperienceListContext = createContext<
  TExperienceListContextValue | undefined
>(undefined);
